<template>
    <header>
        <button 
            class="hamburger hamburger--slider"
            :class="{ 'is-active': showNav }"
            type="button"
            aria-label="Menu"
            aria-controls="navigation"
            v-on:click="handleNav()"
        >
            <span class="hamburger-box">
                <span class="hamburger-inner"></span>
            </span>
        </button>
        <nav id="navigation">
            <ul>
                <li>
                    <router-link
                        v-on:click.native="handleNav()"
                        class="link"
                        :to="{
                            path: '/',
                        }"
                    >Work</router-link>
                </li>
                <li>
                    <router-link
                        v-on:click.native="handleNav()"
                        class="link"
                        :to="{
                            path: '/',
                        }"
                    ><strike>About</strike></router-link>
                </li>
            </ul>
        </nav>
    </header>
</template>

<script>
export default {
    name: "Header",
    data() {
        return {
            showNav: false,
        }
    },
    methods: {
        handleNav() {
            if (this.showNav === false) {
                this.openNav();
            } else {
                this.closeNav();
            }
        },
        openNav() {
            this.showNav = true;
            document.body.classList.add('menu-active');
        },
        closeNav() {
            this.showNav = false;
            document.body.classList.remove('menu-active');
        },
    }
}
</script>

<style lang="scss">

</style>
